import { Trans } from "react-i18next";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useDeactivateApiKeyDialog } from "./DeactivateApiKeyDialog.hooks";

export interface IDeactivateApiKeyDialogProps {
    id: string;
    name: string;
    onCloseDialog: () => void;
    onDeactivated: () => Promise<void> | void;
}

function DeactivateApiKeyDialog(props: IDeactivateApiKeyDialogProps) {
    const { translateString } = useTranslation();
    const { deactivateApiKey, inProgress } = useDeactivateApiKeyDialog(props);

    return (
        <DotLegalInfoDialog
            header={`${translateString("deactivate")}: ${props.name}`}
            btnText={translateString("deactivate")}
            content={<Trans i18nKey="deactivateApiKeyConfirmation" values={{ name: props.name }} />}
            inProgress={inProgress}
            onBtnClick={() => deactivateApiKey()}
            onCloseDialog={props.onCloseDialog}
        />
    );
}

export default DeactivateApiKeyDialog;
